<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1>{{isApproval ? '速報取消承認画面' : '速報取消画面'}}</h1>

<app-sgke100d-result *ngIf="searchResultList?.length > 0" [isApproval]="isApproval" [responseList]="searchResultList"
    (onClickRegistEmitter)="onClickRegist($event)"
    (onClickApplovalEmitter)="onClickApploval($event)"></app-sgke100d-result>